import { Component, Vue,} from 'vue-property-decorator'
import WorkerGoalList from './WorkerGoalList/WorkerGoalList.vue'
import { LoginUser } from '@/types/Component';


@Component({
    components: {
        WorkerGoalList,
    }
})
export default class WorkerGoal extends Vue {
    navItem = "workerGoalItem"
    private isWorkerGoalInert = false

    mounted() {
        this.$watch('$store.getters.currentPageName', this.currentMenu, { immediate: true });
    }

    currentMenu(){
        const path = this.$route.path
        const pathList = path.split('/')
        this.navItem = 'workerGoalItem'
    }

    get hasProducerPlanOnly():LoginUser {
        return this.$store.getters.loginUser.hasProducerPlanOnly
    }

    created(){
    if(this.$store.getters.loginUser.hasProducerPlanOnly === true){
      alert("農薬ナビに参加していない為、利用できません");
      return;
    }
  }

   handleInert(val: boolean) {
    this.isWorkerGoalInert = val
  }

}